export const GA_ID = process.env.REACT_APP_GA4_ID || "";

export function initGA() {
    if (!GA_ID || window.__gaInitialized) return;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    const gtag = function () {
        window.dataLayer.push(arguments);
    };
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA_ID, { send_page_view: false });
    window.__gaInitialized = true;
}

export function trackPageView(path) {
    if (!GA_ID || !window.gtag) return;
    window.gtag("event", "page_view", {
        page_path: path,
        page_title: document.title,
    });
}

export function trackLead(details = {}) {
    if (!GA_ID || !window.gtag) return;
    window.gtag("event", "generate_lead", {
        page_path: window.location.pathname,
        ...details,
    });
}
